module.exports = "/packs/pattern-right-green-3e69c989b86b3612727d5944698fe159.png";